import 'css-chunksrc/client/pages/planzoneMembersPage/menu/styles.scss';export default {
  "menu": "_menu_1wh89_1",
  "addResourceButton": "_addResourceButton_1wh89_5",
  "icon": "_icon_1wh89_25",
  "iconBox": "_iconBox_1wh89_33",
  "visible": "_visible_1wh89_42",
  "list": "_list_1wh89_54",
  "item": "_item_1wh89_71",
  "name": "_name_1wh89_85"
};